import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from'../Component/Header';  
import Footer from'../Component/Footer';  
const Aims = () => {  
  useEffect(() => {
    document.title = 'Aims - St. Francis Xavier School';  
}, []); 
    return (
        <>
        <Header/>
            <div className="innerslide">
                <ul className="breadcrumb">
                    <li><Link to="/"> Home</Link> </li>  
                    <li>School</li>
                    <li>Aims</li>
                </ul>
            </div> 
            <section className="innerbody">
            <div className="container"> 
                    <div className="row aims"> 
                            <h3>Core Ideology</h3>
                           { /* <div className="col-lg-2 col-md-6 col-sm-6">
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Core_Ideology_1.jpg" alt="sfxhisar" className="img-fluid"/>
                            </div> 
                            <div className="col-lg-2 col-md-6 col-sm-6"> 
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Core_Ideology_2.jpg" alt="sfxhisar" className="img-fluid"/> 
                            </div> 
                            <div className="col-lg-2 col-md-6 col-sm-6"> 
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Core_Ideology_3.jpg" alt="sfxhisar" className="img-fluid"/> 
                            </div> 
                            <div className="col-lg-2 col-md-6 col-sm-6"> 
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Core_Ideology_4.jpg" alt="sfxhisar" className="img-fluid"/>
                            </div> 
                            <div className="col-lg-2 col-md-6 col-sm-6">
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Core_Ideology_5.jpg" alt="sfxhisar" className="img-fluid"/>
                            </div> */}
                            <p>The core ideology of this institution is to impart quality education to all its students. The
                            emphasis will be on creation of good human beings and citizens who can in turn contribute to
                            society
                            and its welfare.</p>
                            <h3>Mission Statement</h3>
                          {   /*  <div className="col-lg-2 col-md-6 col-sm-6">
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/mission_1.jpg"
                                    alt="sfxhisar" className="img-fluid"/>
                            
                        </div>
                        <div className="col-lg-2 col-md-6 col-sm-6">
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/mission_2.jpg"
                                    alt="sfxhisar" className="img-fluid"/>
                            
                        </div>
                        <div className="col-lg-2 col-md-6 col-sm-6">
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/mission_3.jpg"
                                    alt="sfxhisar" className="img-fluid"/>
                            
                        </div>
                        <div className="col-lg-2 col-md-6 col-sm-6">
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/mission_4.jpg"
                                    alt="sfxhisar" className="img-fluid"/>
                            
                        </div> */}
                        <p>To prepare dynamic and caring citizens who will meet the challenges of a global society while
                        retaining their traditional values. To be centre for excellence in education which - in keeping
                        with
                        the rich heritage of India- will stress the simultaneous development of the Spirit, Mind and
                        Body?
                        We will endeavor to create compassionate, responsible and innovative global citizens who are
                        committed to the development of India.</p>
                    <h3>Objectives</h3>
                   { /* <div className="col-lg-2 col-md-6 col-sm-6">
                        <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Objectives_1.jpg"
                                alt="sfxhisar" className="img-fluid"/>
                        
                    </div>
                    <div className="col-lg-2 col-md-6 col-sm-6">
                        <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Objectives_2.jpg"
                                alt="sfxhisar" className="img-fluid"/>
                        
                    </div>
                    <div className="col-lg-2 col-md-6 col-sm-6">
                        <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Objectives_3.jpg"
                                alt="sfxhisar" className="img-fluid"/>
                        
                    </div>
                    <div className="col-lg-2 col-md-6 col-sm-6">
                        <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Objectives_4.jpg"
                                alt="sfxhisar" className="img-fluid"/>
                        
                    </div> */}

                    <ul className="mainlist">
                        <li>To provide a near-ideal ambience, outstanding teaching resource and facilities to foster all
                            round development.</li>
                        <li>To nurture and promote intellectual abilities…</li>
                        <li>To inculcate a system of values and purity of thought…</li>
                        <li>To encourage development of scientific and rational thinking...</li>
                        <li>To develop Leadership and a spirit of adventure...</li>
                        <li>To foster the ability to distinguish the right from the wrong, fact from the myth, the grain
                            from the chaff...</li>
                        <li>To encourage community feeling, a sense of justice and the quality of tolerance...</li>
                        <li>To develop self-confidence through a sense of responsibility, devotion, patriotism and
                            discipline./.</li>
                    </ul>
                    </div> 
                </div>
           </section>
           <Footer/>
        </>
    );
}

export default Aims;
